import Nullstack from 'nullstack';
export default function IconEyeglass2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-eyeglass-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 4h-2l-3 10v2.5"
  }), "   ", Nullstack.element("path", {
    d: "M16 4h2l3 10v2.5"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "16",
    x2: "14",
    y2: "16"
  }), "   ", Nullstack.element("circle", {
    cx: "17.5",
    cy: "16.5",
    r: "3.5"
  }), "   ", Nullstack.element("circle", {
    cx: "6.5",
    cy: "16.5",
    r: "3.5"
  }), " ");
}